import { styled } from "@mui/material/styles";

export const EntranceMobile = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	alignItems: "center",
	gap: "15px",
	width: "100%",
	height: "38px",
	cursor: "pointer",
	maxWidth: "135px",

	svg: {
		width: "35px",
		height: "35px",
	},
}));
